import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const TooltipForLanguageWordPointer = styled.div<{
  x?: number;
}>`
  position: absolute !important;
  left: ${({ x }) => (x ? `${x - 8}px` : '0px')};
  width: 0;
  height: 0;
  border-top: 0px solid transparent;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid ${COLORS.white};
  filter: drop-shadow(1px -1px 2px rgba(0, 0, 0, 0.35));
  margin-left: calc(50% - 8px);
  z-index: 1;
`;
